import { render, staticRenderFns } from "./PortCalls.vue?vue&type=template&id=64276681&scoped=true&"
import script from "./PortCalls.vue?vue&type=script&lang=js&"
export * from "./PortCalls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64276681",
  null
  
)

export default component.exports